import { NavLink } from "react-router-dom";

import OutputCombo from "components/OutputCombo";
import GreenBars from "components/svg/GreenBars";

export default function ThermalCost({ className = "", gasData, heatData, showBars }: any) {
  const { eurosGasConsumed = 0, gasConsumed = 0, eurosBoiler = 0, boiler = 0, eurosCHP = 0, chp = 0, price = 0 } = gasData ?? {};
  const { heatByMiners = 0 } = heatData ?? {};

  const gasSavings = heatByMiners / 8790 * price;
  const avgPrice = eurosGasConsumed / gasConsumed;

  return (
    <div className={`output-card ${className}`}>
      {showBars ? (
        <NavLink className="absolute top-6 right-3" to={`${process.env.PUBLIC_URL}/thermal-data`}>
          <GreenBars />
        </NavLink>
      ) : null}
      <div className="flex-shrink-0 mb-3 pt-7 px-7 font-bold">Thermal Costs</div>
      <OutputCombo
        title="Boiler Gas Usage"
        info="Some Info about"
        topValue={eurosBoiler.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
        smallValue={`${boiler.toFixed(0)} m3`}
        className="px-7"
        small
      />
      <OutputCombo
        title="CHP Usage"
        info="Some Info about"
        topValue={eurosCHP.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
        smallValue={`${chp.toFixed(0)} m3`}
        className="mt-1 px-7"
        small
      />
      <div className="px-7 mt-3 bg-slate-100 border-t border-gray-100">
        <OutputCombo
          title="Total Usage"
          info="Some Info about"
          topValue={eurosGasConsumed.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
          smallValue={`${gasConsumed.toFixed(0)} m3`}
          className="mt-3 font-bold text-black"
          small
        />
        <div className="mt-5 flex justify-between items-center">
          <div className="font-bold text-sm">Gas Savings</div>
          <div className="font-semibold text-blue-600">{gasSavings.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}</div>
        </div>
        <div className="mb-7 flex justify-between items-center text-gray-500">
          <div className="text-xs">Average Gas price (€)</div>
          <div className="text-xs text-gray-400 font-sans italic">{avgPrice.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}</div>
        </div>
      </div>
    </div>
  );
}
